<template>
  <div class="align-center-main"  v-loading="loading">

    <!-- 商城banner -->
    <Swiper :bannerList="indexBannerList"></Swiper>


    <!-- 商品分类展示 -->
    <section class="category" v-for="(item, index) in productList" :key="index"
             v-if="item.products && item.products.length >= 1">
      <div class="header">
        <h3>{{item.name}}</h3>
        <span class="checkMore" @click="goCategory(item.id)">查看更多</span>
      </div>
      <ul class="content">
        <li v-for="(v, i) in item.products" :key="i" class="boxShadow" @click="$router.push({ path: '/shoppingMall/productDetalis' , query: { id:v.id, categoryId: v.categoryId}})">
          <img :src="v.thumb[0].img" alt="">
          <div class="title">
            <h4 class="textOver">{{ v.productName }}</h4>
            <p class="price">￥{{ v.price /100 | PriceFilter}}  </p>
          </div>
        </li>
      </ul>
    </section>

     <Nothing v-if="!productList.length && !loading"></Nothing>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import deepcopy from '@/utils/deepcopy';
import Swiper from '@/components/Swiper';


export default {
  data() {
    return{
      loading: true,
      indexBannerList: [],
      productList: [],
      searchStatus: false,
      searchThings: '', //搜索框的文字
      searchList: [],   //搜索结果
      changTime: 5000,
    }
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'user']),
  },
  methods: {
    jumpNew(url) {
      if (url) {
        window.open(url);
      }
    },
    getProductsList(){
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/products/index`,{
        parkId: this.currentParkId,
        currPage: 1,
        pageRows: 3,
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          res.resData.pageList.sort((a,b) => (a.sort - b.sort))
          res.resData.pageList.splice(0,1)
          this.productList = res.resData.pageList ? res.resData.pageList : [];
          if (!this.productList.length) {
          }
        }
      });
    },
    getIndexBanner() {
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/category/banner/list`,{
        parkId: this.currentParkId,
        categoryId: this.$route.query.categoryId,
        currPage: 1,
        pageRows: 50,
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.indexBannerList = res.resData.pageList ? res.resData.pageList : [];
        }
      });
    },
    goCategory(id){
      // console.log(id)
      this.$router.push({ path: '/shoppingMall/category', query: { categoryId: id} });

    },
    changeBanber(bannerIndex) {  // 暂停视频
      const videos = this.$el.querySelectorAll('#lunbo video');
      videos.forEach((val) => {
        val.pause();
      });
    },
    videoClick(src) {
      // 弹框播放视频
      // this.maskFlag = true;
      // this.videoUrl = src;
      this.$el.querySelector(`#video${src}`).play();  // 点击播放视频
    },
  },
  created() {
    this.getProductsList()
    this.getIndexBanner()
  },
  components: {
    Swiper
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.searchStatus = false
      },
    },
  },
}

</script>


<style lang="scss" scoped>

// 首页分类样式
section {
  // padding-top: 40px;
  .header {
    line-height: 40px;
    h3 {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px;
      display: inline-block;
    }
    .checkMore {
      float: right;
      font-style: 14px;
      cursor: pointer;
    }
  }
}

.category {
  min-height: 275px;
  margin-bottom: 20px;
  .content {
    // height: 468px;
    overflow: hidden;
    margin-right: -20px;
    li {
      float: left;
      width: 285px;
      // height: 448px;
      background-color: #fff;
      // margin-right: 20px;
      // margin-bottom: 20px;
      margin: 0 20px 20px 0px;
      .title {
        padding: 0 20px;
      }
      h4 {
        width: 100%;
        height: 24px;
        overflow: hidden;
        font-size: 18px;
        font-weight: 600;
        // margin-bottom: 10px;
        cursor: pointer;
      }
      .price {
        font-size: 20px;
        color: #de2c32;
      }
      img {
        width: 100%;
        height: 285px;
        cursor: pointer;
        border-radius: 4px 4px 0 0;
      }
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}

//公共样式
.in_b{
  display: inline-block;
}
.red{
  background-color: #d9262c;
  color:#fff;
}
.fl{
  float: left;
}
.fr{
  float: right;
}
.pageStyle{
  text-align: center;
  margin-top: 76px;
}


</style>



// WEBPACK FOOTER //
// src/pages/shoppingMall/components/mall/Mall.vue